import React, { useEffect, useRef, useState } from "react";
import "./ResponseLoader.css";
import lottie from "lottie-web";
import animationData from "../../assets/lottie/loader.json";
import { strings } from "../../translations/strings";

const loaderTexts = [
  strings.loader_text_one,
  strings.loader_text_two,
  strings.loader_text_three,
  strings.loader_text_four,
  strings.loader_text_five,
  strings.loader_text_six,
  strings.loader_text_seven,
  strings.loader_text_eight,
  strings.loader_text_nine,
  strings.loader_text_ten,
  strings.loader_text_eleven,
  strings.loader_text_twelve,
  strings.loader_text_thirteen,
  strings.loader_text_fourteen,
  strings.loader_text_fifteen,
  strings.loader_text_sixteen,
];

const eachAnimationIntervalMilliseconds = 8000;

const ResponseLoader = ({ colors }) => {
  const animationContainer = useRef(null);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [usedIndices, setUsedIndices] = useState([]);

  useEffect(() => {
    if (animationContainer.current) {
      const anim = lottie.loadAnimation({
        container: animationContainer.current,
        animationData: animationData,
        renderer: "svg",
        loop: true,
        autoplay: true,
      });

      const intervalId = setInterval(() => {
        let remainingIndices = loaderTexts
          .map((_, index) => index)
          .filter((index) => !usedIndices.includes(index));
        if (remainingIndices.length === 0) {
          setUsedIndices([]);
          remainingIndices = loaderTexts.map((_, index) => index);
        }
        const randomIndex =
          remainingIndices[Math.floor(Math.random() * remainingIndices.length)];
        setCurrentTextIndex(randomIndex);
        setUsedIndices((prevUsedIndices) => [...prevUsedIndices, randomIndex]);
      }, eachAnimationIntervalMilliseconds);

      return () => {
        anim.destroy();
        clearInterval(intervalId);
      };
    }
  }, [usedIndices]);

  const TextLoader = () => {
    const text = loaderTexts[currentTextIndex];
    const [quote, author] = text.split(" - ");
    return (
      <div className="response-loader-text-container">
        <span
          className="response-loader-text"
          style={{ color: colors.primaryText }}
        >
          {currentTextIndex !== 0 ? (
            <>
              <div className="quote">
                <i>{quote}</i>
              </div>
              <div className="author">- {author}</div>
            </>
          ) : (
            text
          )}
        </span>
      </div>
    );
  };

  return (
    <div className="response-loader-container">
      <TextLoader />
      <div
        ref={animationContainer}
        style={{ height: "70%", width: "100%" }}
      ></div>
    </div>
  );
};

export default ResponseLoader;
